export var historyMapper = function (data) {
    var result = [];
    if (data && data.lst && data.lst.length > 0) {
        var product = Array.from(new Set(data.lst.map(function (item) { return item.date.split(",")[0]; })));
        result = product.map(function (item) {
            var _a;
            return {
                date: (_a = data.lst.find(function (list) { var _a; return (_a = list === null || list === void 0 ? void 0 : list.date) === null || _a === void 0 ? void 0 : _a.includes(item); })) === null || _a === void 0 ? void 0 : _a.date,
                list: data.lst
                    .filter(function (list) { var _a; return (_a = list === null || list === void 0 ? void 0 : list.date) === null || _a === void 0 ? void 0 : _a.includes(item); })
                    .map(function (item) {
                    return {
                        date: item.date,
                        name: item.nm,
                        source: item.src,
                        count: item.count,
                        reqId: item.reqId,
                        authStatus: item.authSts,
                        updateStatus: item.updSts,
                    };
                }),
            };
        });
    }
    return result;
};
